import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Loader, Checkbox, Search, useInput } from 'sputnik-ui'
import { Card } from 'components'
import { TablePagination, ListItem, ListItemText } from '@material-ui/core'
import LocationCityIcon from '@material-ui/icons/LocationCity'
import { useTranslation } from 'react-i18next'
import { getAdminLocalities } from 'store/operations'

const SearchableLocalities = ({
  localities,
  err,
  dispatch,
  meta,
  handleLocalityChange,
  selected,
  ...props
}) => {
  const { t } = useTranslation('geo')
  const [page, setPage] = useState(0)
  const [limit, setLimit] = useState(10)
  const { value: query, bind } = useInput()

  const [debouncedQuery, setDebouncedQuery] = useState()

  // Debounce effect
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQuery(query)
    }, 300)

    return () => {
      clearTimeout(handler)
    }
  }, [query])

  useEffect(() => {
    const params = {
      q: debouncedQuery,
      page,
      limit,
    }
    if (!params.q) {
      delete params.q
    }
    dispatch(getAdminLocalities(params))
  }, [dispatch, page, limit, debouncedQuery])

  return (
    <Card
      title={t('geo:locations.city_plural')}
      titleIcon={<LocationCityIcon />}
      {...props}
    >
      <Search {...bind} placeholder="search..." />
      {localities ? (
        localities.map((l) => (
          <ListItem key={l.uuid} button onClick={handleLocalityChange(l.uuid)}>
            <Checkbox
              checked={selected.includes(l.uuid)}
              color="blue"
              style={{
                margin: '0px',
                padding: '0px',
                marginRight: 16,
              }}
            />
            <ListItemText primary={l.full_name} secondary={l.uuid} />
          </ListItem>
        ))
      ) : (
        <Loader msg={t('geo:loading.cities')} err={err} fluid />
      )}
      <TablePagination
        component="div"
        count={meta?.total_count}
        rowsPerPage={limit}
        rowsPerPageOptions={[10, 20, 30]}
        page={page}
        labelRowsPerPage="Строк на странице:"
        labelDisplayedRows={({ from, to, count }) =>
          `${from}-${to} из ${count}`
        }
        onPageChange={(e, page) => {
          setPage(page)
        }}
        onRowsPerPageChange={(e) => {
          setLimit(e.target.value)
        }}
        style={{ background: 'white' }}
      />
    </Card>
  )
}

const mapStateToProps = ({ resourcesAdminLocalities }) => ({
  localities: resourcesAdminLocalities.list,
  meta: resourcesAdminLocalities.meta,
  err: resourcesAdminLocalities.err,
})

export default connect(mapStateToProps)(SearchableLocalities)
